<template>
  <div class="wrapper">
    <a name="pagetop" id="pagetop" class="sr">ページの先頭</a>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
        _/                                                                                                                    _/
        _/      税理士事務所共通ヘッダ                                                                                          _/
        _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <HeaderNav menuflg="2" />
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
           _/                                                                                                                    _/
           _/      画面定義                                                                                                      _/
           _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <div class="body">
      <div class="inner">
        <div class="pankuzu">
          <ul>
            <li>
              <router-link class="ico-home" :to="{ name: 'STFMFM01C01' }"
                >メインページ</router-link
              >
            </li>
            <li>
              <span class="current">ファイル管理</span>
            </li>
          </ul>
        </div>
        <h1 class="h1">ファイル管理</h1>
        <!-- ****  メッセージ表示領域 **** -->
        <div class="frm-row">
          <div class="frm-item grow left">
            <p class="errMsg title-ico ico-warning" v-show="errors != ''">
              <ErrorMessage :errors="errors"></ErrorMessage>
            </p>
          </div>
        </div>

        <!-- No4:スキャナ保存対応 文言変更 -->
        <p class="lead">電子取引・スキャナ保存に係る書類等、任意のファイルを保存できます。</p>
        <!-- No5事業者機能利用権限(電帳法) -->
        <!-- <p class="lead">事業者がファイル管理を利用するためには、［URL通知］ボタンより事業者に「電帳法オプション」(事業者用)ログイン画面のURLを通知してください。</p> -->
        <div class="para">
          <!-- ******************************************************************
                 *  フィルタ条件                                                  *
          ******************************************************************-->
          <div class="criteria">
            <!-- ******************************************************************
                   *  一覧検索                                                      *
            ******************************************************************-->
            <div class="frm-row">
              <div class="frm-item">
                <div
                  class="frm-search frm-size-xl"
                  :class="[isSearched ? showSearched : showUnsearched]"
                >
                  <span class="frm-label">
                    &nbsp;
                    <img src="@/assets/images/TDSDC/icon_search.png" />
                  </span>
                  <input
                    type="search"
                    class="frm-search-text"
                    placeholder="検索キーワード"
                    v-model.trim="searchKey"
                    maxlength="255"
                    ref="refSearchKey"
                  />
                </div>
              </div>
              <div class="frm-item">
                <span class="frm-label">決算日</span>
                <select
                  class="frm-select frm-size-s"
                  :class="[isMonthSelected ? showSelected : showUnselected]"
                  v-model="monthSelected"
                  v-show="!isMonthDisable"
                  @change="handleMonthChange"
                >
                  <option
                    v-for="item in monthList"
                    :key="item.code"
                    :value="item.code"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <select
                  class="frm-select frm-size-s setvalue"
                  :disabled="true"
                  v-show="isMonthDisable"
                >
                  <option>詳細指定中</option>
                </select>
              </div>

              <div class="frm-item">
                <span class="frm-label">主担当者</span>
                <select
                  class="frm-select frm-size-m"
                  :class="[
                    isMainPersonSelected ? showSelected : showUnselected,
                  ]"
                  v-model="mainPersonSelected"
                  v-show="!isMainPersonDisable"
                  @change="handleMainPersonChanged"
                >
                  <option
                    v-for="item in getPersonInChargeSelectList"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.userName }}
                  </option>
                </select>
                <select
                  class="frm-select frm-size-m setvalue"
                  :disabled="true"
                  v-show="isMainPersonDisable"
                >
                  <option>詳細指定中</option>
                </select>
              </div>
              <!--絞込条件設定-->
              <div class="frm-item">
                <button
                  class="frm-btn"
                  :class="[isFilterUsed ? showUsed : showUnused]"
                  @click="handleShowFilter"
                ></button>
              </div>
              <!--すべてクリアボタン-->
              <div class="frm-item" style="margin-left: 10px">
                <button
                  class="frm-btn-control ico ico-filter-close"
                  :disabled="isResetDisabled"
                  @click="handleReset"
                >
                </button>
              </div>
            </div>
          </div>
          <!-- ******************************************************************
                 *  ファイル管理情報一覧                                                *
          ******************************************************************-->
          <div v-show="showCount" class="frm-item alignright">
            <p v-show="showSelectCount">{{ selectCount.toLocaleString() }}/{{ totalCount.toLocaleString() }}件</p>
            <p v-show="!showSelectCount">{{ totalCount.toLocaleString() }}件</p>
          </div>
          <div class="table-wrap" style="margin-top: 0px">
            <table class="table-select single-select">
              <colgroup>
                <!--事業者コード-->
                <col style="width: 120px" />
                <!--事業者名-->
                <col style="width: auto" />
                <!--法人個人区分-->
                <!-- <col style="width: 90px" /> -->
                <col style="width: 230px" />
                <!--決算日-->
                <col style="width: 100px" />
                <!-- No5事業者機能利用権限(電帳法) start-->
                <!--主担当者-->
                <col style="width: 140px" />
                 <!--URL通知-->
                <!-- <col style="width: 170px" /> -->
                <!-- No5事業者機能利用権限(電帳法) end-->
                <!--登録ファイル数-->
                <col style="width: 180px" />
                <!--ファイル保存日時-->
                <col style="width: 180px" />
              </colgroup>
              <thead>
                <tr>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('businessOperatorCode')"
                  >
                    事業者<br />コード
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorCode' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorCode' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('businessOperatorName')"
                  >
                    事業者名
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorName' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorName' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('businessOperatorType')">
                    法人個人区分
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'businessOperatorType' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'businessOperatorType' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover"
                    @click="sortData('accountClosingDate')"
                  >
                    決算日
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'accountClosingDate' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'accountClosingDate' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortData('personInChargeUserName')"
                  >
                    主担当者
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'personInChargeUserName' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'personInChargeUserName' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <!-- No5事業者機能利用権限(電帳法)-->
                  <!-- <th
                    class="sort hover"
                    @click="sortData('')"
                  >
                    事業者に対する<br />URL通知
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == '' && sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == '' &&
                          !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th> -->
                  <th class="sort hover" @click="sortData('fileCount')">
                    登録ファイル数
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'fileCount' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'fileCount' && !sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortData('dataUpdateDate')">
                    ファイル保存日時
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sort.key == 'dataUpdateDate' && sort.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sort.key == 'dataUpdateDate' && !sort.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="info in filteredFileManageInfo"
                  :key="info.businessOperatorId"
                >
                  <td class="alignleft">
                    <span>{{ info.businessOperatorCode }}</span>
                  </td>
                  <td class="alignleft">
                    <span>{{ info.businessOperatorName }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{
                        corporationIndividualFormat(info.businessOperatorType)
                      }}
                    </span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{
                        info.accountClosingMonth +
                        "月" +
                        info.accountClosingDay +
                        "日"
                      }}
                    </span>
                  </td>
                  <td class="alignleft">
                    <span>{{
                      info.personInChargeUserName
                        ? info.personInChargeUserName
                        : "-"
                    }}</span>
                  </td>
                  <!-- No5事業者機能利用権限(電帳法)-->
                  <!-- <td class="aligncenter">
                    <div class="frm-row" style="display: flex; justify-content: center">
                      <button
                        class="frm-btn-operation"
                        type="button"
                        @click="SentMail(info)"
                      >
                        <span class="aligncenter">URL通知</span>
                      </button>
                    </div>
                  </td> -->
                  <td class="aligncenter">
                    <div class="frm-row" style="display: flex; justify-content: center">
                      <span>{{ info.fileCount.toLocaleString() }}ファイル</span>
                    </div>
                    <div class="frm-row" style="display: flex; justify-content: center">
                      <button
                        class="frm-btn-operation"
                        type="button"
                        @click="handleFileConfirmation(info.tzaffmBopDataFileHeader)"
                      >
                        ファイルの確認
                      </button>
                    </div>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{ formatDateTime_Date(info.dataUpdateDate) }}
                    </span>
                    <br />
                    <span>
                      {{ formatDateTime_Time(info.dataUpdateDate) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="table-select single-select" v-show="noDataPrompt">
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：                                                                                                              _/
         _/      処理完了画面(STDSDC01C04ProcessingCompleteModal)                                                                         _/
          _/     絞り込み画面(STFMFM02C10FilterCompleteModal)                                                         _/
         _/                                                                                                                    _/
    _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/-->
    <STDSDC01C04ProcessingCompleteModal></STDSDC01C04ProcessingCompleteModal>
    <STFMFM02C10FilterCompleteModal
      ref="STFMFM02C10FilterCompleteModal"
      :isShow="isFilterShow"
      :pageId="pageId"
      :loginSystem="loginSystem"
      :keyWordFilterInit="searchKey"
      :bopDataFilterInit="bopDataFilterInit"
      :STFMFM02C01FilterInit="STFMFM02C01FilterInit"
      @SearchBtn="SearchBtn"
      @CancelBtn="CancelBtn"
    ></STFMFM02C10FilterCompleteModal>
    <!-- No5事業者機能利用権限(電帳法) -->
    <!-- <STFMFM02C30SentMailtNotificationContentModal
      :isProcessShow="STFMFM02C30Modle.isProcessShow"
      :businessOperatorId="STFMFM02C30Modle.businessOperatorId"
      :accountingOfficeName="STFMFM02C30Modle.accountingOfficeName"
      :businessOperatorName="STFMFM02C30Modle.businessOperatorName"
      :mailAddress="STFMFM02C30Modle.mailAddress"
      @cancelSend="cancelSend"
    ></STFMFM02C30SentMailtNotificationContentModal> -->
  </div>
</template>

<script>
import moment from "moment";
import { mapMutations } from "vuex";
import _ from "lodash";
import ErrorMessage from "@/components/ErrorMessage.vue";
import HeaderNav from "@/components/AccountingHeader.vue";
import STDSDC01C04ProcessingCompleteModal from "@/components/STDSDC01C04ProcessingCompleteModal.vue";
import STFMFM02C10FilterCompleteModal from "@/components/STFMFM02C10FilterCompleteModal.vue";
// No5事業者機能利用権限(電帳法)
// import STFMFM02C30SentMailtNotificationContentModal from "@/components/STFMFM02C30SentMailtNotificationContentModal.vue";
import Common from "@/util/common.js";
import Validation from "@/util/validation.js";
import {
  CORPORATION_DIVISION_LIST,
  MONTH_LIST,
  WITH_WITHOUT_LIST,
  FUNCTION_USAGE_AUTHORITY_FOR_BOP_LIST,
  DETAIL_DURING_DATE_LIST,
  DETAIL_BLANK_NONPERMISSION_LIST,
  DETAIL_BUSINESS_CODE_LIST,
} from "@/util/data.js";
import {
  CORPORATION_INDIVIDUAL_DIVISION,
} from "@/util/enum.js";
import {
  API_STFMFM02C01,
  API_STFMFM02C01_SetBop,
  API_STFMFM02C01_SetFilter,
  // API_STFMFM02C01_GetMailAddress,  //No5事業者機能利用権限(電帳法)
} from "@/api/Modules/FM02/STFMFM02C01.js";

export default {
  name: "STFMFM02C01",
  components: {
    HeaderNav,
    ErrorMessage,
    STDSDC01C04ProcessingCompleteModal,
    STFMFM02C10FilterCompleteModal,
    // STFMFM02C30SentMailtNotificationContentModal, //No5事業者機能利用権限(電帳法)
  },
  data() {
    return {
      isMonthDisable: false,
      isMainPersonDisable: false,
      isDisabled: false,
      isShowProcessingConfirmModal: false,
      expandFlag: true,
      designateFlag: true,
      corporationDivisionSelected: 0,
      monthSelected: 0,
      mainPersonSelected: 0,
      accountSelected: 0,
      notificationDestinationSelected: 0,
      bopCodeSelected: 0,
      bopCode: "",
      bopNameSelected: 0,
      bopName: "",
      detailDuringDateSelected: 0,
      functionUsageAuthorityForBopSelected: 0,
      monthStart: "",
      dayStart: "",
      monthEnd: "",
      dayEnd: "",
      searchKey: "",
      highlights: [],
      highlightIndex: -1,
      sort: {
        key: "123", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      totalCount: 0,
      selectCount: 0,
      showSelectCount: false,
      showCount: true,
      allData: [],
      fileManageInfo: [],
      deleteRow: {},
      changeData: {},
      errors: [],
      corporationDivisionList: CORPORATION_DIVISION_LIST,
      monthList: MONTH_LIST,
      withWithoutList: WITH_WITHOUT_LIST,
      functionUsageAuthorityForBopList: FUNCTION_USAGE_AUTHORITY_FOR_BOP_LIST,
      detailDuringDateList: DETAIL_DURING_DATE_LIST,
      detailBlankNonpermissionList: DETAIL_BLANK_NONPERMISSION_LIST,
      // true:処理確認画面表示 / false:処理画面非表示
      isConfirmShow: false,
      // 入力:入力内容を表示 / 未入力:エリア非表示
      textArea: Common.getMessage("MTCL2029", ["", ""]),
      // 入力:入力リストを☑チェックボックスで表示 / 未入力:エリア非表示(赤字)
      deleteCheck: Common.getMessage("MTCL2048", [
        "当事業者情報に関連する情報（収集書類情報、認証情報なども含め）",
      ]),
      businessOperatorCode: undefined,
      pageId: "STFMFM02C01",
      isSearchKeyEnter: false,
      noDataPrompt: false,
      noDataMsg: Common.getMessage("MTCL1118", ["ファイル管理情報"]),
      startFlg: false,
      mainPersonSelect: [],
      showUsed: "frm-btn-control setvalue ico ico-filter",
      showUnused: "frm-btn-control ico ico-filter",
      loginSystem: 0,
      isFilterShow: false,
      showSearched: "frm-search frm-size-xl setvalue",
      showUnsearched: "frm-search frm-size-xl",
      showSelected: "frm-select frm-size-s setvalue ",
      showUnselected: "frm-select frm-size-s ",
      copyBopDataFilter: {},
      bopDataFilterInit: {},
      STFMFM02C10FilterInit: {},
      isFilterUsed: false,
      personInChargeOption: 0,
      personInChargeInput: "",
      bopOpenFunctionCondition: 0,
      STFMFM02C10Modle: {},
      STFMFM02C01FilterInit: {},
      isProcessShow: false,
      businessOperatorId: 0,
      businessOperatorName: "",
      mailAddress: "",
      // No5事業者機能利用権限(電帳法)
      // STFMFM02C30Modle: {
      //   isProcessShow: false,
      //   businessOperatorId: 0,
      //   accountingOfficeName: "",
      //   businessOperatorName: "",
      //   mailAddress: "",
      // },
      accountingOfficeName: "",
    };
  },
  mounted() {
    this.processDialogue(true);
    //検索キーワード適用
    this.isSearchKeyEnter = true;
    // ファイル管理ヘッダー情報リストを取得する
    API_STFMFM02C01().then((response) => {
      if (response.errorCD) {
        if (response.errorCD == "MTCL1036") {
          this.totalCount = 0;
          this.showCount = true;
          this.noDataPrompt = true;
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      } else {
        // 税理士事務所名を保存
        this.accountingOfficeName = response.customerName;
        this.loginSystem = response.loginSystem;
        this.startFlg = true;
        this.fileManageInfo = Object.assign(
          // response.tzafdcBopDataHeaders
          response.stfmfM02C01BopDataHeaders
        );
        // 事業者ソートのためにフリガナがない場合は事業者名を代入しておく
        this.fileManageInfo = this.fileManageInfo.map(function (value) {
          if (value.businessOperatorNameF == "") {
            value.businessOperatorNameF = value.businessOperatorName;
          }
          return {
            ...value,
            personInChargeUserName: value.personInCharge?.userName
              ? value.personInCharge?.userName
              : "",
          };
        });
        this.allData = [...this.fileManageInfo];

        // 保存されているフィルタ条件の適用
        if (
          response.stfmfM02C01Filter.result != "0001" &&
          response.stfmfM02C01Filter
        ) {
          this.STFMFM02C01FilterInit = response.stfmfM02C01Filter;
          this.monthSelected = response.stfmfM02C01Filter.accountClosingMonth;
          this.mainPersonSelected = response.stfmfM02C01Filter.personInCharge;
          if (this.monthSelected == 99) {
            this.isMonthDisable = true;
          } else {
            this.isMonthDisable = false;
          }
          if (this.mainPersonSelected == 99) {
            this.isMainPersonDisable = true;
          } else {
            this.isMainPersonDisable = false;
          }
        }
        if (response.bopDataFilter.result != "0001" && response.bopDataFilter) {
          this.bopDataFilterInit = response.bopDataFilter;
          this.bopCodeSelected =
            response.bopDataFilter.businessOperatorCodeOption;
          this.bopCode = response.bopDataFilter.businessOperatorCode;
          this.bopNameSelected =
            response.bopDataFilter.businessOperatorNameOption;
          this.bopName = response.bopDataFilter.businessOperatorName;
          this.corporationDivisionSelected =
            response.bopDataFilter.businessOperatorType;
          this.detailDuringDateSelected =
            response.bopDataFilter.accountClosingOption;
          this.monthStart = response.bopDataFilter.accountClosingFromMonth;
          this.dayStart = response.bopDataFilter.accountClosingFromDay;
          this.monthEnd = response.bopDataFilter.accountClosingToMonth;
          this.dayEnd = response.bopDataFilter.accountClosingToDay;
          this.functionUsageAuthorityForBopSelected =
            response.bopDataFilter.functionUsageAuthorityForBop;
          this.searchKey = response.keywordFilter.searchKey;
          this.isFilterUsed = response.bopDataFilter.motoPageHandleShowBtn;
          this.personInChargeOption =
            response.bopDataFilter.personInChargeOption;
          this.personInChargeInput = response.bopDataFilter.personInCharge;
          this.handleSetting();
        }
        if (response.keywordFilter.result != "0001" && response.keywordFilter) {
          this.searchKey = response.keywordFilter.searchKey;
        }

        //フィルター利用確認
        this.checkFilterUsed();
      }
      this.processDialogue(false);

      this.$nextTick(function () {
        this.initFocus();
      });
    });
  },
  watch: {
    searchKey: {
      handler: "filterContext",
      immediate: true,
    },
  },
  computed: {
    //リセット制御
    isResetDisabled() {
      if (
        !this.searchKey &&
        this.mainPersonSelected == 0 &&
        this.monthSelected == 0 &&
        !this.isFilterUsed
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 主担当者をフィルタ状態にする
    isMainPersonSelected() {
      return this.mainPersonSelected != 0 ? true : false;
    },
    // 決算日をフィルタ状態にする
    isMonthSelected() {
      return this.monthSelected != 0 ? true : false;
    },
    // 検索キーワードをフィルタ状態にする
    isSearched() {
      return this.searchKey != "" ? true : false;
    },
    // 詳細_事業者コードテキストコントロールを非活性にする
    isBopCodeDisabled() {
      return this.bopCodeSelected == 0 ? true : false;
    },
    // 詳細_事業者名テキストコントロールを非活性にする
    isBopNameDisabled() {
      return this.bopNameSelected == 0 ? true : false;
    },
    // ソート、通常フィルタ
    filteredFileManageInfo() {
      var filterInfo = this.fileManageInfo;
      const searchCorporationDivision = this.corporationDivisionSelected;
      const searchMonth = this.monthSelected;
      const personInCharge = this.mainPersonSelected;
      const searcgFunctionUsageAuthorityForBop = this.functionUsageAuthorityForBopSelected;

      // 法人個人区分
      if (searchCorporationDivision != 0) {
        filterInfo = filterInfo.filter((item) => {
          return item.businessOperatorType == searchCorporationDivision;
        });
      }
      // 決算日
      if (searchMonth != 0 && searchMonth != 99) {
        filterInfo = filterInfo.filter((item) => {
          return item.accountClosingMonth == searchMonth;
        });
      }

      // 主担当者
      if (personInCharge != 0 && 
        personInCharge != DETAIL_BUSINESS_CODE_LIST[3].code &&
        personInCharge != 99) 
      {
        filterInfo = filterInfo.filter((item) => {
          return item.personInChargeUserName == personInCharge;
        });
      }else if (personInCharge == DETAIL_BUSINESS_CODE_LIST[3].code) {
        filterInfo = filterInfo.filter((item) => {
          return item.personInChargeUserName == "";
        });
      }
      //検索キーワード
      if (this.searchKey) {
        filterInfo = filterInfo.filter((item) => {
          return (
            item.personInChargeUserName?.includes(this.searchKey) ||
            item.businessOperatorCode.includes(this.searchKey) ||
            item.businessOperatorName.includes(this.searchKey) ||
            String(item.fileCount).includes(this.searchKey) ||
            this.corporationIndividualFormat(
              item.businessOperatorType
            ).includes(this.searchKey) ||
            (
              item.accountClosingMonth +
              "月" +
              item.accountClosingDay +
              "日"
            ).includes(this.searchKey) ||
            //this.withWithoutFormat(item.hasBopUser).includes(this.searchKey) ||
            // this.functionUsageAuthorityForBopFormat(
            //   item.functionUsageAuthorityForBop
            // ).includes(this.searchKey) ||
            this.formatDateTime_Date(item.dataUpdateDate).includes(
              this.searchKey
            ) ||
            this.formatDateTime_Time(item.dataUpdateDate).includes(
              this.searchKey
            )
          );
        });
      }

      //TODO ソート処理追加
      filterInfo = Common.listSort(this.sort.key, this.sort.isAsc, filterInfo);

      return filterInfo;
    },
    // 主担当者プルダウンドロップリスト
    getPersonInChargeSelectList() {
      const set = new Set(
        this.allData
          .map((item) => item.personInChargeUserName)
          .filter((item) => item != "")
          .sort()
      );
      let personInChargeList = [];
      for (let item of set) {
        personInChargeList.push({ userName: item, value: item });
      }
      personInChargeList.unshift({ userName: "指定しない", value: 0 });
      //未設定
      personInChargeList.push({
        userName: DETAIL_BUSINESS_CODE_LIST[3].name,
        value: DETAIL_BUSINESS_CODE_LIST[3].code,
      });
      return personInChargeList;
    },
  },
  methods: {
    ...mapMutations("businessModule", [
      "processDialogue",
    ]),

    // **********************************************
    // * 検索アイコンをクリック時、該当する部分の色を変える
    // **********************************************
    searchNext() {
      if (this.highlights.length > 0) {
        let targetIndex = this.highlightIndex;
        const maxIndex = this.highlights.length - 1;

        targetIndex++;

        if (targetIndex > maxIndex) {
          targetIndex = 0;
        }

        this.highlightIndex = targetIndex;

        for (let i = 0; i < this.highlights.length; i++) {
          const target = this.highlights[i];

          target.classList.remove("currentHighlight");

          if (i === targetIndex) {
            target.classList.add("currentHighlight");
            const offsetTop = target.offsetTop - 10;
            const scrollTop = Math.max(0, offsetTop); // 数値がマイナスの場合はゼロにする
            window.scrollTo(0, scrollTop);
          }
        }
      }
    },
    // // **********************************************
    // // * ハイライト表示
    // // **********************************************
    // highlight(val) {
    //   const reg = new RegExp(this.searchKey, "gi");
    //   return val.replace(
    //     reg,
    //     (match) => `<span class='highlight'>${match}</span>`
    //   );
    // },
    // **********************************************
    // * キーワードが変更になったら全てのハイライト部分を取得するようにする
    // **********************************************
    filterContext(keyword) {
      if (this.startFlg) {
        this.checkFilterUsed();
      }
      //this.highlightIndex = -1;
      //this.highlights = document.getElementsByClassName("highlight");
      if (this.isSearchKeyEnter) {
        // フィルター条件の保存
        this.saveFilter();
      }
    },

    // **********************************************
    // * ソート実施
    // **********************************************
    sortData(key) {
      Common.sortData(key, this);
    },

    // 法人個人区分のフォーマット
    corporationIndividualFormat(data) {
      // 法人
      if (data == CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.text;

        // 個人
      } else if (data == CORPORATION_INDIVIDUAL_DIVISION.Individual.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.Individual.text;
      }
    },
    // // 事業者アカウントの表示フォーマット
    // withWithoutFormat(data) {
    //   // 有り
    //   if (data) {
    //     return this.withWithoutList[1].name;
    //   }
    //   // 無し
    //   else {
    //     return this.withWithoutList[2].name;
    //   }
    // },
    // // 事業者に対する機能利用権限の表示フォーマット
    // functionUsageAuthorityForBopFormat(data) {
    //   // 有り
    //   if (data) {
    //     return this.functionUsageAuthorityForBopList[0].name;
    //   }
    //   // 無し
    //   else {
    //     return this.functionUsageAuthorityForBopList[1].name;
    //   }
    // },
    // **********************************************
    // * 日付のフォーマット(YYYY/MM/DD)
    // **********************************************
    formatDateTime_Date(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    },
    // **********************************************
    // * 日付のフォーマット(HH:mm:ss)
    // **********************************************
    formatDateTime_Time(value) {
      if (value) {
        return moment(String(value)).format("HH:mm:ss");
      }
    },

    //TODO
    //ファイル数のフォーマット

    // 詳細_決算日入力値チェック
    dateValidate() {
      // 「指定しない」はチェックしない
      if (
        this.detailDuringDateSelected != 0 &&
        this.detailDuringDateSelected != 3
      ) {
        return Validation.checkFilterDateMD(
          this.detailDuringDateSelected,
          this.monthStart,
          this.dayStart,
          this.monthEnd,
          this.dayEnd,
          "決算日"
        );
      }

      return "";
    },
    // 通常フィルタ_決算日を取得
    handleMonthChange(e) {
      this.checkFilterUsed();
      this.monthSelected = e.target.value;
      this.saveFilter();
    },
    // 通常フィルタ_主担当者を取得
    handleMainPersonChanged(e) {
      this.mainPersonSelected = e.target.value;
      this.checkFilterUsed();
      this.saveFilter();
    },
    // フィルタ_DB保存
    saveFilter() {
      // パラメータ設定
      const normalFileter = {
        accountClosingMonth: this.monthSelected,
        personInCharge: this.mainPersonSelected,
      };

      const keyWordFilter = {
        searchKey: this.searchKey,
        pageID: this.pageId,
      };

      let params = {
        STFMFM02C01Filter: normalFileter,
        keyWordFilter: keyWordFilter,
      };

      // フィルター条件保存処理
      API_STFMFM02C01_SetFilter(params);
    },
    // 設定ボタンをクリック
    handleSetting() {
      this.fileManageInfo = this.allData;
      this.errors = [];

      // 事業者コードが「指定しない」以外の場合フィルタする
      if (this.bopCodeSelected != 0) {
        // 「右記から始まる」の場合
        if (this.bopCodeSelected == 3) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return _.startsWith(element.businessOperatorCode, this.bopCode);
            }
          );
          // 「右記を含む」の場合
        } else if (this.bopCodeSelected == 1) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return _.includes(element.businessOperatorCode, this.bopCode);
            }
          );
          // 「右記を含まない」の場合
        } else if (this.bopCodeSelected == 2) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return !_.includes(element.businessOperatorCode, this.bopCode);
            }
          );
        }
      }
      // 事業者名が「指定しない」以外の場合フィルタする
      if (this.bopNameSelected != 0) {
        // 「右記から始まる」の場合
        if (this.bopNameSelected == 3) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return _.startsWith(element.businessOperatorName, this.bopName);
            }
          );
          // 「右記を含む」の場合
        } else if (this.bopNameSelected == 1) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return _.includes(element.businessOperatorName, this.bopName);
            }
          );
          // 「右記を含まない」の場合
        } else if (this.bopNameSelected == 2) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return !_.includes(element.businessOperatorName, this.bopName);
            }
          );
        }
      }

      // 決算日のフィルタ
      if (
        this.detailDuringDateSelected != 0 &&
        this.detailDuringDateSelected != 3
      ) {
        var inputStartDate =
          Number(this.monthStart) * 100 + Number(this.dayStart);
        // 指定期間
        if (this.detailDuringDateSelected == DETAIL_DURING_DATE_LIST[1].code) {
          this.designateFlag = false;
          var inputEndDate = Number(this.monthEnd) * 100 + Number(this.dayEnd);
          let msg = this.dateValidate();
          if (msg != "YearendStraddle") {
            this.fileManageInfo = this.fileManageInfo.filter(
              (element) => {
              var sourceDate =
                element.accountClosingMonth * 100 + element.accountClosingDay;
                return (
                  inputStartDate <= sourceDate && sourceDate <= inputEndDate
                );
              }
            );
          } else {
            // 年末またぎの場合の検索
            var inputEndDateBefore = 12031;
            var inputStartDateAfter = 101;

            this.fileManageInfo = this.fileManageInfo.filter(
              (element) => {
              var sourceDate =
                element.accountClosingMonth * 100 + element.accountClosingDay;
              return (
                (inputStartDate <= sourceDate &&
                  sourceDate <= inputEndDateBefore) ||
                (inputStartDateAfter <= sourceDate &&
                  sourceDate <= inputEndDate)
              );
              }
            );
          }
          // 指定日
        } else if (
          this.detailDuringDateSelected == DETAIL_DURING_DATE_LIST[2].code
        ) {
          this.designateFlag = true;
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            const sourceDate =
              element.accountClosingMonth * 100 + element.accountClosingDay;
            return inputStartDate === sourceDate;
            }
          );
        }
      }

      // 主担当者が「指定しない」以外の場合　フィルタする
      if (this.personInChargeOption != 0) {
        // 「右記を含む」の場合
        if (this.personInChargeOption == 1) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return _.includes(
              element.personInChargeUserName,
              this.personInChargeInput
            );
            }
          );
          // 「右記を含まない」の場合
        } else if (this.personInChargeOption == 2) {
          this.fileManageInfo = this.fileManageInfo.filter(
            (element) => {
            return !_.includes(
              element.personInChargeUserName,
              this.personInChargeInput
            );
            }
          );
        }
      }

      this.checkFilterUsed();
    },
    // すべての条件をクリア
    handleReset() {
      this.designateFlag = true;
      this.errors = [];
      this.corporationDivisionSelected = 0;
      this.monthSelected = 0;
      this.mainPersonSelected = 0;
      this.bopCodeSelected = 0;
      this.bopCode = "";
      this.bopNameSelected = 0;
      this.bopName = "";
      this.detailDuringDateSelected = 0;
      this.monthStart = "";
      this.dayStart = "";
      this.monthEnd = "";
      this.dayEnd = "";
      this.searchKey = "";
      this.fileManageInfo = this.allData;
      this.isMonthDisable = false;
      this.isMainPersonDisable = false;
      this.isFilterUsed = false;
      this.checkFilterUsed();
      this.sort = {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      };
      this.$refs.STFMFM02C10FilterCompleteModal.handleReset();

      // フィルター条件の保存
      this.saveFilter();
    },
    // ファイルの確認ボタンをクリック
    handleFileConfirmation(selectedRow) {
      // エラー情報の初期化
      this.errors = [];
      this.processDialogue(true);
      // 選択した事業者情報を保存しファイル一覧画面(電子取引)に遷移する
      API_STFMFM02C01_SetBop(selectedRow).then((response) => {
        this.processDialogue(false);
        if (response.result == "0000") {
          //正常時
          this.$router.push({
            name: "STFMFM02C29",
          });
        } else {
          // エラー表示
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });

      //this.$redirect({ name: "STFMFM02C29" });
    },
    // URL通知ボタンをクリック
    // SentMail(selectedRow) {
    //   this.processDialogue(true);
    //   // エラー情報の初期化
    //   this.errors = [];

    //   let params = {
    //     businessOperatorId:
    //       selectedRow.tzaffmBopDataFileHeader.businessOperatorId,
    //   };

    //   API_STFMFM02C01_GetMailAddress(params).then((response) => {
    //     if (response.result == "0000") {
    //       this.businessOperatorId =
    //         selectedRow.tzaffmBopDataFileHeader.businessOperatorId;
    //       this.businessOperatorName =
    //         selectedRow.tzaffmBopDataFileHeader.businessOperatorName;
    //       //宛先
    //       this.mailAddress = "";
    //       if (response.stfmfM02C01BopDataHeaders[0].addressList != null) {
    //         for (var item of response.stfmfM02C01BopDataHeaders[0].addressList) {
    //           this.mailAddress += item;
    //           this.mailAddress += "\n";
    //         }
    //       }

    //       // STFMFM02C30画面表示
    //       this.STFMFM02C30Modle = {
    //         isProcessShow: true,
    //         businessOperatorId: this.businessOperatorId,
    //         accountingOfficeName: this.accountingOfficeName,
    //         businessOperatorName: this.businessOperatorName,
    //         mailAddress: this.mailAddress,
    //       };
    //     } else {
    //       // エラー表示
    //       this.errors.push(
    //         Common.createError(
    //           response.errorCD,
    //           Common.getMessage(response.errorCD, [])
    //         )
    //       );
    //     }
    //     this.processDialogue(false);
    //   });
    // },
    // 通知内容モーダルでキャンセルボタン押下時
    // cancelSend() {
    //   this.STFMFM02C30Modle.isProcessShow = false;
    // },

    // **********************************************
    // * 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.refSearchKey.focus();
    },
    setChangeDate(newData) {
      this.changeData = newData;
    },
    // **********************************************
    // * フィルター利用確認
    // **********************************************
    checkFilterUsed() {
      this.showCount = true;
      this.totalCount = this.allData.length;
      if (this.totalCount == 0) {
        this.noDataPrompt = true;
      } else {
        this.noDataPrompt = false;
      }

      if (
        !this.searchKey &&
        this.monthSelected == 0 &&
        this.mainPersonSelected == 0 &&
        !this.isFilterUsed
      ) {
        this.showSelectCount = false;
      } else {
        this.showSelectCount = true;
        this.selectCount = this.filteredFileManageInfo.length;
        if (this.selectCount == 0) {
          this.noDataPrompt = true;
        }
      }
    },
    SearchBtn(filterParam) {
      this.searchKey = filterParam.searchKey;
      this.copyBopDataFilter = filterParam.returnBopDataFilter;
      this.isFilterUsed = filterParam.motoPageHandleShowBtn;

      if (this.copyBopDataFilter.returnCodeKessanDate == 99) {
        this.isMonthDisable = true;
        this.monthSelected = this.copyBopDataFilter.returnCodeKessanDate;
      } else {
        this.isMonthDisable = false;
        this.monthSelected = this.copyBopDataFilter.returnCodeKessanDate;
      }
      if (this.copyBopDataFilter.returnCodePersonInCharge == 99) {
        this.isMainPersonDisable = true;
        this.mainPersonSelected =
          this.copyBopDataFilter.returnCodePersonInCharge;
      } else {
        this.isMainPersonDisable = false;
        this.mainPersonSelected =
          this.copyBopDataFilter.returnCodePersonInCharge;
      }

      //業者コード
      this.bopCodeSelected = this.copyBopDataFilter.businessOperatorCodeOption;
      this.bopCode = this.copyBopDataFilter.businessOperatorCode;
      //事業者名
      this.bopNameSelected = this.copyBopDataFilter.businessOperatorNameOption;
      this.bopName = this.copyBopDataFilter.businessOperatorName;
      //法人個人区分
      this.corporationDivisionSelected =
        this.copyBopDataFilter.businessOperatorType;
      //決算日
      this.detailDuringDateSelected =
        this.copyBopDataFilter.accountClosingOption;
      this.monthStart = this.copyBopDataFilter.accountClosingFromMonth;
      this.dayStart = this.copyBopDataFilter.accountClosingFromDay;
      this.monthEnd = this.copyBopDataFilter.accountClosingToMonth;
      this.dayEnd = this.copyBopDataFilter.accountClosingToDay;
      if (this.detailDuringDateSelected == 3) {
        this.monthSelected = parseInt(this.monthStart);
      }
      //主担当者名
      this.personInChargeOption = this.copyBopDataFilter.personInChargeOption;
      this.personInChargeInput = this.copyBopDataFilter.personInCharge;
     
      this.handleSetting();
      // フィルター条件の保存
      this.saveFilter();
      this.isFilterShow = false;
    },
    CancelBtn() {
      this.isFilterShow = false;
    },
    handleShowFilter() {
      this.isFilterShow = true;
      this.STFMFM02C01FilterInit.accountClosingMonth = this.monthSelected;
      this.STFMFM02C01FilterInit.managerOption = this.mainPersonSelected;
      this.STFMFM02C01FilterInit.personInCharge = this.mainPersonSelected;
    },
  },
};
</script>
<style scoped>
.table-wrap{
  min-width: 1200px;
}
</style>
